module.exports = __webpack_public_path__ + "static/media/naturopathy.4c268330.svg";